import first from "lodash/first";
import last from "lodash/last";
import upperCase from "lodash/upperCase";

import { QuizType } from "../store";

export const getQuizTypeFromURL = (url: string): QuizType => {
    return upperCase(first(last(url.split("/"))?.split("-"))) as QuizType;
};
